export const ESTADOS_LIQUIDACION = {
    PENDIENTE: 1,
    APROBADO: 2,
    DESESTIMADO: 3,
    SAP: 4
}